import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { ManageSupplier } from 'src/types/manage-suppliers/ManageSupplier';
import {
  SupplierFilterRequest,
  SupplierFilterResponse,
} from 'src/types/manage-suppliers/SupplierFilter';
import axiosInstance from 'src/utils/axios';
import { mapSupplier } from './supplierMapper';

export interface UseSuppliersQueryParams {
  request: SupplierFilterRequest;
  filterBy?: string;
  enabled?: boolean;
}

export interface SuppliersQueryResult {
  items: ManageSupplier[];
  totalRecords: number;
}

export async function fetchSuppliers(
  request: SupplierFilterRequest,
  filterBy?: string,
  signal?: AbortSignal
): Promise<SupplierFilterResponse> {
  const url = filterBy
    ? `${api.filterSuppliers}?filterBy=${encodeURIComponent(filterBy)}`
    : api.filterSuppliers;
  const response = await axiosInstance.post<SupplierFilterResponse>(url, request, { signal });
  return response.data;
}

const useSuppliersQuery = ({ request, filterBy, enabled = true }: UseSuppliersQueryParams) =>
  useQuery<SupplierFilterResponse, Error, SuppliersQueryResult>({
    queryKey: queryKeys.manageSuppliers.list({ ...request, filterBy }),
    enabled,
    placeholderData: keepPreviousData,
    queryFn: () => fetchSuppliers(request, filterBy),
    select: (data) => ({
      items: data.items.map(mapSupplier),
      totalRecords: data.totalRecords,
    }),
  });

export default useSuppliersQuery;
